/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(document).on("click", "#btn_postal_code", function(){
  	var code = $("#input_code").val();
  
     if(isNaN(code)){
        console.log("Postal Code Not Number");
        $(".input_error_text").show();
     }else{
       for(var x = 0; x < postal.length; x++){
         if(isNaN(postal[x].code) == false){
           code = code * 1;
           var postalcode = postal[x].code *1;
           if(postalcode == code){
              $(".input_error_text").hide();
              window.location.href = postal[x].url;
              break;
           }else{
             $(".input_error_text").show();
           }
         }else{
           $(".input_error_text").show();
         }
       }
     }
});